import { render } from "./Attendance.vue?vue&type=template&id=460087f6"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"

import "./Attendance.vue?vue&type=style&index=0&id=460087f6&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__